import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.sekisonagnote.jp';

/**
 * CanonicalManager
 * 
 * 全ページで canonical と og:url と hreflang を自動管理する
 */
export const CanonicalManager: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    let pathname = window.location.pathname;
    
    // 末尾スラッシュの正規化（Apacheのディレクトリ挙動とSitemapに合わせる）
    if (!pathname.endsWith('/')) {
      pathname = `${pathname}/`;
    }
    
    const canonicalUrl = `${BASE_URL}${pathname}`;

    // hreflang用のパス推論
    let jaPath = pathname;
    let enPath = pathname;
    
    if (pathname.startsWith('/en/')) {
      jaPath = pathname.replace(/^\/en/, '');
      if (!jaPath.startsWith('/')) jaPath = '/' + jaPath;
    } else {
      enPath = pathname === '/' ? '/en/' : `/en${pathname}`;
    }
    
    // パス正規化
    if (!jaPath.endsWith('/')) jaPath = `${jaPath}/`;
    if (!enPath.endsWith('/')) enPath = `${enPath}/`;
    if (jaPath === '//') jaPath = '/';
    if (enPath === '/en//') enPath = '/en/';

    const jaUrl = `${BASE_URL}${jaPath}`;
    const enUrl = `${BASE_URL}${enPath}`;

    // 既存のタグを全て削除
    document.querySelectorAll('link[rel="canonical"]').forEach(tag => tag.remove());
    document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(tag => tag.remove());
    document.querySelectorAll('meta[property="og:url"]').forEach(tag => tag.remove());

    // 新しい canonical タグを追加
    const canonicalTag = document.createElement('link');
    canonicalTag.rel = 'canonical';
    canonicalTag.href = canonicalUrl;
    document.head.appendChild(canonicalTag);

    // 新しい hreflang タグを追加
    const addHreflang = (lang: string, url: string) => {
      const tag = document.createElement('link');
      tag.rel = 'alternate';
      tag.hreflang = lang;
      tag.href = url;
      document.head.appendChild(tag);
    };

    addHreflang('ja', jaUrl);
    addHreflang('en', enUrl);
    addHreflang('x-default', jaUrl);

    // 新しい og:url タグを追加
    const ogUrlTag = document.createElement('meta');
    ogUrlTag.setAttribute('property', 'og:url');
    ogUrlTag.content = canonicalUrl;
    document.head.appendChild(ogUrlTag);

  }, [location.pathname]);

  return null;
};
